import { combineReducers } from 'redux';
import { program, programSelectors } from './program';
import { programList } from './programList';
import { tabs, tabsSelectors } from './tabs';
import { tags } from './tags';
import { userProgramsList } from './userProgramList';
import { video, videoSelectors } from './video';
import { videoList } from './videoList';

const programs = combineReducers({
  tags: tags.reducer,
  tabs: tabs.reducer,
  programList: programList.reducer,
  userProgramsList: userProgramsList.reducer,
  videoList: videoList.reducer,
  video: video.reducer,
  program: program.reducer,
});

export const { reset, setSearch, updateProgram, removeProgram } = programList.actions;

export const { setVideo } = video.actions;
export const { setSelectedVideoList } = program.actions;

export const { selectTab } = tabsSelectors;
export const { selectVideo } = videoSelectors;
export const { selectedVideosList } = programSelectors;

export default programs;
